(function () {
    'use strict';

    angular
        .module('flightWatch')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('flightWatch', {
                sticky: true,
                url: '/flight-watch',
                views: {
                    'flightWatchView': {
                        templateUrl: 'flight-watch/views/flight-watch.tpl.html',
                        controller: 'FlightWatchCtrl',
                        controllerAs: 'flightWatch'
                    }
                }
            });
    }
}());
